import { AppointmentCheckupStatus as AppointmentCheckupStatusEnum } from '../enums';

export const AppointmentCheckupStatus = {
	[AppointmentCheckupStatusEnum.COMPLETE]: 'Completo',
	[AppointmentCheckupStatusEnum.SCHEDULED]: 'Programado',
	[AppointmentCheckupStatusEnum.NONE]: 'Pendiente',
	[AppointmentCheckupStatusEnum.NOTAPPLIED]: 'No aplicado',
	[AppointmentCheckupStatusEnum.REQUESTED]: 'Requisitado',
	[AppointmentCheckupStatusEnum.PENDENT]: 'Pendiente',
	[AppointmentCheckupStatusEnum.PENDING_RESULT]:
		'No acudió o pendiente de resultado',
	[AppointmentCheckupStatusEnum.FINISHED]: 'Completo',
	[AppointmentCheckupStatusEnum.FINISHED_WITHOUT_MEDICAL_RECORD]: 'Completo',
};
